define('models/SidedishCollection',['underscore','ObjectCollection','LocalStorage','models/SidedishModel'],function (_,ObjectCollection,LocalStorage,SidedishModel) {
    //
    // Collection Sidedish
    //
    var SidedishCollectionPrototype = {

        name:'SidedishCollection',
        model:SidedishModel,

        initialize:function(){
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this,arguments);
            //
        },
        findById:function(id){
            return this.findWhere({id_cross_selling:id});
        },
        filtredChild:function(id_parent){
            return _(this.filter({id_parent:id_parent}));
        },
        atRoot:function(index){
            return this.atChild(index,'0');
        },
        atChild:function(index,id_parent){
            return this.filtredChild(id_parent)._wrapped[index];
        },
        sizeRoot:function(){
            return this.filtredChild('0').size();
        },
        eachChild:function(id_parent,iteratee){
            this.filtredChild(id_parent).each(iteratee);
        },
        eachRoot:function(iteratee){
           this.eachChild('0',iteratee);
        },
        getSerializedSelection:function(){
            return JSON.stringify(this.map(function(sidedish){
                return sidedish.getSimplifiedSelection()
            }));
        }
    };

    var SidedishCollection = ObjectCollection.extend(SidedishCollectionPrototype);

    var createSelectionItem = SidedishModel.createSelectionItem;

    // cette fonction prépare une selection pour l'afficher sur la fiche produit.
    SidedishCollection.prepareSelection = function(sidedishes,app,accompagnements,presetSelection){
        var cart = app.getCart(), presetIndex = false;
        var collection = new SidedishCollection(sidedishes.filter(function(s,si)
        {
            var isVisible = (!!cart.isNowLunch() && s.midday || (!cart.isNowLunch() && s.evening)),
                cat = app.getCategory(s.id_category),
                isNotEmpty = cat ? cat.getProducts(true).size() > 0 : false,
                isGroupedList = _(['grouped_list','custom_box_42']).contains(s.template),
                id_product_default = s.id_product_default,
                id_product_immutable = s.id_product_immutable,
                initialSelection = [],
                isChildrenVisibles = false,
                filtred,
                pos_custom_box = _(s.pos_custom_box || []).clone(); // position of selection in custom box

            // les templates groupé (BYOP) et box à composer (custom_box)
            // héritent de principes fonctionnels proches.
            if(isGroupedList){
                // on cherche dans les sidedish / cross_selling enfant si tous ne sont pas indisponibles
                isChildrenVisibles = sidedishes.filter(function(sc){
                    var isChild = sc.id_parent === s.id_cross_selling, isVisible = isChild;
                    if(isChild){
                        var childCat = app.getCategory(sc.id_category);
                        isVisible = childCat ? childCat.getProducts(true).size() > 0 : false;
                    }
                    return isVisible;
                }).length > 0;
            }
            filtred = isVisible && (isNotEmpty || isChildrenVisibles);

            if(filtred) {

                function shiftPosition() {
                    return pos_custom_box.shift() || '*';
                }

                if (accompagnements && accompagnements.models){
                    // édition d'une selection existante
                    _(accompagnements.filter({id_cross_selling: parseInt(s.id_cross_selling)})).each(function(accompagnement){
                        var id_product = accompagnement.get('id_product'),
                            qty = accompagnement.getQuantity(),
                            qtyImmutable = _(s.id_product_immutable||[]).countBy(function(id){return id===id_product}).true || 0;
                        initialSelection.push(createSelectionItem(id_product,qty,0,qtyImmutable,shiftPosition));
                    });
                }else {
                    // nouvelle selection
                    _(_.countBy(id_product_immutable)).each(function (qty, id_product) {
                        // ajoute les produits immuables à la selection
                        initialSelection.push(createSelectionItem(id_product, qty, 0, qty,shiftPosition))
                    });
                    function setDefault(qty, id_product) {
                        // ajoute les produits par défaut à la selection
                        var defaultSelection = _(initialSelection).findWhere({id: id_product});
                        if (!defaultSelection) {
                            defaultSelection = createSelectionItem(id_product, qty, qty, 0,shiftPosition);
                            initialSelection.push(defaultSelection)
                        } else {
                            for (var i = 0; i < qty; i++) defaultSelection.positions.push(shiftPosition());
                            defaultSelection.quantity += qty;
                            defaultSelection.default = qty;
                        }
                    }
                    var preset = false;
                    if(presetSelection && (preset = presetSelection[si])) {
                        // préselection (product boost)
                        if(preset.length>0){  // si il y a une quantité selectionnée
                            presetIndex = si; // en cas de boost produit
                        }else if(!presetIndex){
                            presetIndex = 0; // on est à minima sur la première étape.
                        }
                        _(_.countBy(preset,'id')).each(setDefault);
                    }else{
                        // selection par défaut
                        _(_.countBy(id_product_default)).each(setDefault);
                    }
                }
                // attribute;
                s.selection = initialSelection;
            }
            return filtred;
        }));
        collection.presetIndex = presetIndex;
        return collection;
    }

    return SidedishCollection;
});
